module.exports = __webpack_public_path__ + "static/icons/icon-break-6bd0f1fe55b59b147d9b5f070cc0ed7e.svg";